// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_wrapper__bzCD\\+ {
  position: relative;
  border: 1px solid var(--mui-palette-grey-400);
  border-radius: 8px;
  width: -moz-fit-content;
  width: fit-content;
  box-sizing: border-box;
}

.card_wrapperPointer__aowVp {
  cursor: pointer;
}

.card_wrapperPointer__aowVp:hover {
  background: var(--mui-palette-primary-100);
  border-color: var(--mui-palette-primary-400);
}

.card_wrapperPointer__aowVp:hover .card_linkIcon__Wcy\\+d {
  background: var(--mui-palette-primary-400);
}

.card_linkIcon__Wcy\\+d {
  position: absolute;
  right: 16px;
  cursor: pointer;
  border-radius: 6px;
}

.card_linkIconTop__V53Lo {
  top: 15px;
}

.card_linkIconBottom__OUQj\\+ {
  bottom: 15px;
}
.card_noBorder__d\\+ZIK {
  border: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/card/card.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":[".wrapper {\n  position: relative;\n  border: 1px solid var(--mui-palette-grey-400);\n  border-radius: 8px;\n  width: fit-content;\n  box-sizing: border-box;\n}\n\n.wrapperPointer {\n  cursor: pointer;\n}\n\n.wrapperPointer:hover {\n  background: var(--mui-palette-primary-100);\n  border-color: var(--mui-palette-primary-400);\n}\n\n.wrapperPointer:hover .linkIcon {\n  background: var(--mui-palette-primary-400);\n}\n\n.linkIcon {\n  position: absolute;\n  right: 16px;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.linkIconTop {\n  top: 15px;\n}\n\n.linkIconBottom {\n  bottom: 15px;\n}\n.noBorder {\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `card_wrapper__bzCD+`,
	"wrapperPointer": `card_wrapperPointer__aowVp`,
	"linkIcon": `card_linkIcon__Wcy+d`,
	"linkIconTop": `card_linkIconTop__V53Lo`,
	"linkIconBottom": `card_linkIconBottom__OUQj+`,
	"noBorder": `card_noBorder__d+ZIK`
};
export default ___CSS_LOADER_EXPORT___;
